import React, { useEffect, useState } from 'react'
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { t } from "i18next";
import Form from 'react-bootstrap/Form';

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setQuestionAnswerList } from '../../system/redux/reducers/surveyReducer';

export default function SurveyDynamicMultipleDropDown(props) {
    const dispatch = useDispatch();
    const [question, setQuestion] = useState(props.question);
    console.log(props);

    const [optionsList, setOptionsList] = useState(question.optionList);
    const [selectedOptionValues, setSelectedOptionValues] = useState([]);
    
    const handleChangeMultiple = (event) => {
        // console.log( event.target);
        const { options } = event.target;

        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
            if (options[i].selected) {
                value.push(options[i].value);
            }
        }

        if (question.maxAnswerAllowed !== -1) {
            if (value.length <= question.maxAnswerAllowed) {
                setSelectedOptionValues(value);
            }
        } else {
            setSelectedOptionValues(value);
        }
        
    };

    useEffect(()=>{
        var payload = {
            id: question.id
        };

        if(selectedOptionValues && selectedOptionValues?.length > 0){
            payload = {
                id: question.id, 
                answerList: [{
                    dynamicOptionIdList: selectedOptionValues.map(option => ( option )), 
                    questionOptionId: optionsList[0].id,
                    answerDescription: JSON.stringify(optionsList)
                }],
            };
        }
        
        console.log(payload);
        dispatch(setQuestionAnswerList(payload));
    },[selectedOptionValues])

    return (
        <div>
            <>
                <Form.Select
                    multiple
                    native
                    value={selectedOptionValues}
                    onChange={handleChangeMultiple}
                    label="Native"
                    inputProps={{
                        id: "question-id-" + question.id + "-option-id-0",
                        className: "question-id-" + question.id + "-option-id-0",
                        name: "questionList[" + question.questionSequenceNo + "].answerList[0].questionOptionId"
                    }}
                >
                    {optionsList.map((item, index) => (
                        <option key={item.dynamicOptionId} value={item.dynamicOptionId}>
                            {item.name}
                        </option>
                    ))}
                </Form.Select>
            </>
        </div>
    );
}
